/**
 * LineLoader -- thin horizontal indeterminate progress bar.
 *
 * Shows a brand-green bar that slides across the container width
 * when `loading` is true. The track always occupies its 3px height
 * so toggling visibility never causes layout shift.
 */
import styles from './LineLoader.module.scss';

// ============================================
// TYPES
// ============================================

export interface LineLoaderProps {
  /** Whether the loader animation is visible. @default false */
  loading?: boolean;
  /** Additional CSS class applied to the root element */
  className?: string;
}

// ============================================
// COMPONENT
// ============================================

function LineLoader({ loading = false, className }: LineLoaderProps) {
  const rootClasses = [styles.root, className].filter(Boolean).join(' ');

  return (
    <div
      className={rootClasses}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-busy={loading}
      aria-label="Loading"
    >
      <div
        className={[styles.bar, loading && styles.barActive]
          .filter(Boolean)
          .join(' ')}
      />
    </div>
  );
}

export default LineLoader;
